import { createLogic } from 'redux-logic'
import unionBy from 'lodash.unionby'
import { LogicDeps } from '@chegg-wt/core/state'
import { POPULAR_STYLES } from '@chegg-wt/core/constants/styles'
import { handleStylesResponses } from '../../utils/styles'
import { AppState, FSACreatorPayload } from '../types'
import { currentStyleSelector } from '../currentProject/selectors'
import { stylesRequested, stylesRequestFailed, stylesRequestSucceeded } from './actions'
import { ActionTypes } from './constants'
import { stylesSelector } from './selectors'

export const initStylesLogic = createLogic<AppState, any, any, LogicDeps>({
  type: ActionTypes.LOAD_STYLES,
  async process({ api, getState }) {
    const state = getState()
    const currentStyle = currentStyleSelector(state)
    const isCurrentStylePopular = POPULAR_STYLES.find(
      (style) => currentStyle === style.id
    )
    try {
      // Save ourselves a request if currentStyle is undefined or one of the popular styles
      let styleRequests = [api.oneGraph.getStylesV2({ keyword: '' })]
      if (currentStyle && !isCurrentStylePopular) {
        styleRequests = [
          api.oneGraph.getStylesV2({ keyword: currentStyle }),
          ...styleRequests,
        ]
      }
      const responses = await Promise.all(styleRequests)
      const { resultStyles, styles } = handleStylesResponses(responses)

      const firstStyles =
        responses.length > 1 ? [...POPULAR_STYLES] : [...POPULAR_STYLES, ...styles]

      const results =
        responses.length > 1 ? [...firstStyles, ...resultStyles] : firstStyles
      return stylesRequestSucceeded(results)
    } catch (e) {
      return stylesRequestFailed(e)
    }
  },
})

export const stylesRequestedLogic = createLogic<
  AppState,
  FSACreatorPayload<typeof stylesRequested>,
  any,
  LogicDeps
>({
  type: ActionTypes.STYLES_REQUESTED,
  async process({ api, action, getState }) {
    const { page, query } = action.payload
    try {
      const response = (await api.oneGraph.getStylesV2({ keyword: query, page })).data
        .citationStylesV2

      // if it's the first page, don't add previous styles to results
      const updatedStyles =
        page === 1
          ? response.results
          : unionBy(stylesSelector(getState()), response.results, 'id')

      return stylesRequestSucceeded(updatedStyles)
    } catch (e) {
      return stylesRequestFailed(e)
    }
  },
})
